module.exports = __webpack_public_path__ + "static/media/VidstarInstaProfile.08d88141.png";